import { createActionGroup, props } from '@ngrx/store';
import { AppleDevice, EnableLostModeCommand } from '@era/locations-sdk';
import { ErrorModel } from '@era/app';

// ============================================================================
// CONTAINER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AppleDeviceContainerActions = createActionGroup({
  source: 'Apple Device Container',
  events: {
    'Apple Device requested': props<{ udid: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const AppleDeviceApiActions = createActionGroup({
  source: 'Apple Device API',
  events: {
    'Apple Device loaded': props<{ appleDevice: AppleDevice }>(),
    'Apple Device loaded error': props<{ error: ErrorModel }>(),
    'Device put in Lost Mode': props<{ udid: string }>(),
    'Failed to put device into Lost Mode': props<{ error: ErrorModel }>(),
    'Device taken out of Lost Mode': props<{ udid: string }>(),
    'Failed to take device out of Lost Mode': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// CONTEXT MENU ACTIONS (Group - using createActionGroup)
// ============================================================================

export const DeviceContextMenuActions = createActionGroup({
  source: 'Device details context menu',
  events: {
    'Device Lost Mode command sent': props<{ udid: string; enableLostModeCommand: EnableLostModeCommand }>(),
    'Device Disable Lost Mode command sent': props<{ udid: string }>(),
  },
});
